import { render, staticRenderFns } from "./PreviewTableFull.vue?vue&type=template&id=22d959aa&"
import script from "./PreviewTableFull.vue?vue&type=script&lang=js&"
export * from "./PreviewTableFull.vue?vue&type=script&lang=js&"
import style0 from "./PreviewTableFull.vue?vue&type=style&index=0&id=22d959aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports